import React from 'react';
import '../styles/TourCategories.css'
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectCoverflow, Pagination, Navigation, Autoplay } from 'swiper/modules';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import ScrollReveal from './ScrollReveal';


const categories = [
    {
        title: 'Cultural Tours',
        image: '/assets/culture.jpg',
    },
    {
        title: 'Nature & Adventure',
        image: '/assets/naturecategoriess.jpg',
    },
    {
        title: 'Historical Sites',
        image: '/assets/kwamenkrumah.jpg',
    },
    {
        title: 'Beach Getaways',
        image: '/assets/beach.jpg',
    },
    {
        title: 'Culinary Experiences',
        image: '/assets/1.webp',
    },
    {
        title: 'Cultural Tours',
        image: '/assets/culture.jpg',
    },
    {
        title: 'Nature & Adventure',
        image: '/assets/naturecategoriess.jpg',
    },
    {
        title: 'Historical Sites',
        image: '/assets/kwamenkrumah.jpg',
    },
    {
        title: 'Beach Getaways',
        image: '/assets/beach.jpg',
    },
    {
        title: 'Culinary Experiences',
        image: '/assets/1.webp',
    }
];

const TourCategories = () => {
    return (
        <div className="bg-gray-100 py-16 px-4 overflow-hidden tour-categories">
            <div className="container mx-auto text-center">
                <ScrollReveal animationClass="animate-fade-up" threshold={0.1} delay={200}>
                    <h2 className="text-3xl md:text-4xl font-semibold text-gray-800 font-cormorant-upright mb-4">Explore by Category</h2>
                    <p className="text-gray-800 mb-8 max-w-2xl mx-auto">Discover the perfect African experience tailored to your interests.</p>
                </ScrollReveal>
                <ScrollReveal animationClass="animate-fade-in-slow" threshold={0.1} delay={400}>
                    <Swiper
                        effect={'coverflow'}
                        grabCursor={true}
                        centeredSlides={true}
                        slidesPerView={'auto'}
                        loop={true}
                        autoplay={{
                            delay: 3000,
                            disableOnInteraction: false,
                        }}
                        coverflowEffect={{
                            rotate: 50,
                            stretch: 0,
                            depth: 100,
                            modifier: 1,
                            slideShadows: true,
                        }}
                        pagination={{
                            clickable: true,
                        }}
                        navigation={true}
                        modules={[EffectCoverflow, Pagination, Navigation, Autoplay]}
                        className="mySwiper lg:px-40 mx-auto px-40"
                    >
                        {categories.map((category, index) => (
                            <SwiperSlide key={index}>
                                <div className="relative w-full h-full rounded-xl shadow-2xl overflow-hidden group">
                                    <img src={category.image} alt={category.title} className="w-full h-full object-cover" />
                                    <div className="absolute inset-0 bg-black/30"></div>
                                    <h3 className="absolute bottom-5 left-5 text-white text-xl font-bold drop-shadow-lg">
                                        {category.title}
                                    </h3>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </ScrollReveal>
            </div>
        </div>
    );
};

export default TourCategories;